import { AxiosInstance, AxiosResponse } from 'axios';
import config from '../../config';
import { CsvExportOptionsEnum, ICVProject, IExportCSV, IPageableResponse, IPdfLinkedinProfile } from '@recone/models';

// const CV_PROJECT_BASE_PATH = 'cv-project';
const CV_PROJECT_BASE_PATH = `${config.service.BASE_URL}/cv-project`;
const GET_CV_PROJECTS_PATH = `${CV_PROJECT_BASE_PATH}/list`;
const GET_REQUESTED_CV_PROJECTS_PATH = `${CV_PROJECT_BASE_PATH}/list-requested`;
const GET_CV_PROJECT_BY_ID_PATH = `${CV_PROJECT_BASE_PATH}/byId`;
const ADD_TO_CV_PROJECT_PATH = `${CV_PROJECT_BASE_PATH}/add-cv`;
const ADD_CV_PROJECT_PATH = `${CV_PROJECT_BASE_PATH}/add`;
const UPDATE_CV_PROJECT = `${CV_PROJECT_BASE_PATH}/update`;
const APPROVE_ALL_CV_PROFILES = `${CV_PROJECT_BASE_PATH}/approve-all-profiles`;
const EXPORT_CSV_PROJECT_PATH = `${CV_PROJECT_BASE_PATH}/export`;

export const getCvProjects = (
  axiosInstance: AxiosInstance,
  page = 0,
  limit = config.service.QUERY_DEFAULT_LIMIT
): Promise<AxiosResponse<IPageableResponse<ICVProject>>> =>
  axiosInstance.get(`${GET_CV_PROJECTS_PATH}?page=${page}&limit=${limit}`);

export const getCvProjectById = (
  axiosInstance: AxiosInstance,
  id: string
): Promise<AxiosResponse<{ project: ICVProject; profiles: IPdfLinkedinProfile[] }>> =>
  axiosInstance.get(`${GET_CV_PROJECT_BY_ID_PATH}/${id}`);

export const addToCvProject = (
  axiosInstance: AxiosInstance,
  file: File,
  projectId: string
): Promise<AxiosResponse<IPdfLinkedinProfile>> => {
  const formData = new FormData();
  formData.append('profile-cv', file);
  formData.append('projectId', projectId);
  return axiosInstance.post(`${ADD_TO_CV_PROJECT_PATH}`, formData);
};

export const addCvProject = (
  axiosInstance: AxiosInstance,
  name: string,
  description: string
): Promise<AxiosResponse<{ message: string; data: ICVProject }>> =>
  axiosInstance.post(`${ADD_CV_PROJECT_PATH}`, { name, description });

export const getRequestedCvProjects = (
  axiosInstance: AxiosInstance,
  page = 0,
  limit = config.service.QUERY_DEFAULT_LIMIT
): Promise<AxiosResponse<IPageableResponse<ICVProject>>> =>
  axiosInstance.get(`${GET_REQUESTED_CV_PROJECTS_PATH}?page=${page}&limit=${limit}`);

export const approveCvProject = (
  axiosInstance: AxiosInstance,
  projectId: string
): Promise<AxiosResponse<{ message: string }>> => axiosInstance.post(`${CV_PROJECT_BASE_PATH}/${projectId}`, {});

export const approveAllCvProfiles = (
  axiosInstance: AxiosInstance,
  projectId: string
): Promise<AxiosResponse<{ message: string }>> => axiosInstance.put(`${APPROVE_ALL_CV_PROFILES}`, { projectId });

export const removeCvProject = (axiosInstance: AxiosInstance, projectId: string) =>
  axiosInstance.delete(`${CV_PROJECT_BASE_PATH}/${projectId}`);

export const updateCvProject = (
  axiosInstance: AxiosInstance,
  cvProject: ICVProject
): Promise<AxiosResponse<ICVProject>> => {
  return axiosInstance.put(`${UPDATE_CV_PROJECT}`, { cvProject });
};

export const notifyUploadIsFinished = (
  axiosInstance: AxiosInstance,
  projectId: string
): Promise<AxiosResponse<{ message: string }>> => axiosInstance.patch(`${CV_PROJECT_BASE_PATH}/${projectId}`, {});

export const exportCsvFromCVProject = (
  axiosInstance: AxiosInstance,
  id: string,
  exportOptions: CsvExportOptionsEnum
): Promise<AxiosResponse<IExportCSV>> =>
  axiosInstance.post(`${EXPORT_CSV_PROJECT_PATH}/${id}`, {
    id: id,
    exportOptions
  });
